module.exports = __webpack_public_path__ + "static/media/RP-A_S_Fashion_Necchi_Blue_Orange.3e49f9f2.png";